import script from "./salary.vue?vue&type=script&setup=true&lang=js"
export * from "./salary.vue?vue&type=script&setup=true&lang=js"

import "./salary.vue?vue&type=style&index=0&id=6a06ad27&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a06ad27"]])

export default __exports__